import React from "react";
import { Box, Typography } from "@mui/material";
import closeIcon from "@iconify/icons-mdi/close";
import { InlineIcon } from "@iconify/react";

interface MyTimesheetShowRequestDialogHeaderProps {
  label: string;
  close: () => void;
  isMobile: boolean;
}

export const MyTimesheetShowRequestDialogHeader: React.FC<
  MyTimesheetShowRequestDialogHeaderProps
> = ({ label, close, isMobile }) => {
  return (
    <Box
      id="my-sheet-show-request-dialog-header"
      padding="10px 0px 10px 18px"
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      width={isMobile ? "auto" : "536px"}
    >
      <Typography
        variant="h6"
        style={{
          color: "#919699",
        }}
      >
        {label}
      </Typography>
      <InlineIcon
        id="close-dialog"
        icon={closeIcon}
        width="24px"
        style={{
          marginRight: "8px",
          color: "#919699",
          cursor: "pointer",
        }}
        onClick={close}
      />
    </Box>
  );
};

export default MyTimesheetShowRequestDialogHeader;
